import React from 'react';
import styles from './index.modules.scss';
import { Icon } from '@shakkerai/components';

export const NewMessageTip = (props) => {
  const { newRecordCount, onRefresh, onClose } = props;

  return (
    <div className={styles.newMessageContainer} data-role="gen-history-trigger">
      <div className={styles.content}>
        <div className={styles.message}>{newRecordCount} New Images Generated</div>
        <div
          className={styles.click}
          onClick={() => {
            onRefresh();
          }}
        >
          Click to view
        </div>
        <Icon className={`icon-border_close-1 ${styles.close}`} color="#5C636B" fontSize={14} onClick={onClose} />
      </div>
    </div>
  );
};
